module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "dedication"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("For Holly Dauphin Fields-"), _c('br'), _vm._v("and the sweet memories of friends and family"), _c('br'), _vm._v("who left us too soon.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-76785229","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/003dedication.vue
// module id = 63
// module chunks = 0